import Joi from 'joi';

export interface IConfig {
  [key: string]: unknown;
}

export const schemaMap = Joi.object({}).unknown(true);
export const schemaMapDefault = Joi.object({}).unknown(true);

export const defaultConfig: IConfig = {};
